import { useState, useEffect } from 'react';
import './Forms.css';
import { createRole, updateRole } from '../services/RoleServices';

function RolesForm({ companyId, onClose, onRoleSaved, roleToEdit }) {
    const [roleData, setRoleData] = useState({
        name: '',
        description: '',
        companyId: companyId
    });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (roleToEdit) {
            setRoleData({
                id: roleToEdit.id,
                name: roleToEdit.name || '',
                description: roleToEdit.description || '',
                companyId: companyId
            });
        }
    }, [roleToEdit, companyId]);

    const validateForm = () => {
        const newErrors = {};
        if (!roleData.name.trim()) {
            newErrors.name = 'El nombre del cargo es requerido';
        }

        if (!roleData.description.trim()) {
            newErrors.description = 'La descripción es requerida';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setRoleData(prev => ({ ...prev, [name]: value }));
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        setLoading(true);
        setMessage('');

        try {
            if (roleToEdit && roleToEdit.id) {
                await updateRole(roleToEdit.id, roleData);
            } else {
                await createRole(roleData);
            }

            setMessage({
                text: roleToEdit ? 'Rol actualizado exitosamente' : 'Rol creado exitosamente',
                type: 'success',
            });

            setTimeout(() => {
                onRoleSaved();
                onClose();
            }, 1000);
        } catch (error) {
            console.error('Error al guardar rol:', error);
            setMessage({
                text: `Error: ${error.response?.data?.message || error.message}`,
                type: 'error',
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-container">
            <div className="form-container-user">
                <h2>{roleToEdit ? 'Editar Rol' : 'Crear Nuevo Rol'}</h2>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="name">Nombre del cargo*</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            placeholder="Ej: Asesor Comercial"
                            value={roleData.name}
                            onChange={handleChange}
                            className={errors.name ? 'input-error' : ''}
                        />
                        {errors.name && <span className="error-message">{errors.name}</span>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="description">Descripción*</label>
                        <textarea
                            id="description"
                            name="description"
                            placeholder="Describe las responsabilidades del cargo"
                            value={roleData.description}
                            onChange={handleChange}
                            className={errors.description ? 'input-error' : ''}
                            rows="4"
                        />
                        {errors.description && <span className="error-message">{errors.description}</span>}
                    </div>

                    <div className="form-actions">
                        <button type="button" onClick={onClose} className="btn-cancel" disabled={loading}>
                            Cancelar
                        </button>
                        <button type="submit" className="btn-submit" disabled={loading}>
                            {loading ? (
                                <>
                                    <i className="icon-spinner spinner"></i>
                                    {' '}Guardando...
                                </>
                            ) : roleToEdit ? 'Actualizar' : 'Crear Rol'}
                        </button>
                    </div>

                    {message && (
                        <div className={`form-message ${message.type}`}>
                            {message.text}
                        </div>
                    )}
                </form>
            </div>
        </div>
    );
}

export default RolesForm;
